// @flow
import * as constants from './constants';

import { createAction } from 'redux-actions';

export const audioDataReceived = createAction(constants.AUDIO_DATA_RECEIVED);
export const clearData = createAction(constants.CLEAR_DATA);
export const getAudioData = createAction(constants.GET_AUDIO_DATA);



// WEBPACK FOOTER //
// ./src/core/state/ui/sensor-logs/audio-player/actions.js